module.exports = __webpack_public_path__ + "static/media/sp_sns.09757fea.png";